<template>
  <div v-if="ir !== null">
    <h3 class="mb-5">Corporate Governance</h3>
    <div class="h4 mb-5">顯示於Investor Relations頁面</div>

    <div>
      <!-- Title -->
      <div class="form-item d-flex pa-5">
        <div class="w-174px mr-6px"><h4>Title</h4></div>
        <div class="flex-grow-1 flex-basis-0">
          {{ ir.corporate_governance_title }}
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-180px">
          <h4 class="mb-10px">Picture</h4>
        </div>
        <div class="d-flex justify-end flex-grow-1 flex-basis-0">
          <div
            class="bg-cover bg-center w-305px h-187px"
            :style="{
              'background-image': `url(${ir.corporate_governance_pic||defaultBanner})`,
              'border-radius': '8px',
            }"
          ></div>
        </div>
      </div>
    </div>

    <h3 class="mt-5">Links</h3>
    <div class="py-5">編輯連結內容</div>
    <!-- Items -->
    <div>
      <div
        class="form-item d-flex py-3 align-center"
        v-for="(item, i) in ir.governance_tabs"
        :key="i"
      >
        <div class="h4 ml-5">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ir: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    defaultBanner: 'https://dummyimage.com/305x187.jpg',
  }),
};
</script>

<style></style>
